"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var Navigation = /** @class */ (function (_super) {
    __extends(Navigation, _super);
    function Navigation(props) {
        var _this = _super.call(this, props) || this;
        _this.buildList = function (links, level, link) {
            for (var l = 0; l < links.length; l += 1) {
                var obj = links[l];
                obj.heading = obj.title;
            }
            var linksLength = links.length;
            linksLength -= 1;
            return (React.createElement("ul", { className: "list-reset flex w-full level-" + level + " items-center content-start justify-start -mx-1-6" }, links
                ? links.map(function (link, i) { return (React.createElement(Snippets.Menu, { key: i, link: link, lastChild: i == linksLength, firstChild: i == 0, activeDropdown: _this.props.activeDropdown, previousDropdown: _this.props.previousDropdown, handleHover: _this.props.handleHover })); })
                : null));
        };
        return _this;
    }
    Navigation.prototype.render = function () {
        var _a = this.props, id = _a.id, linklist = _a.linklist;
        return (React.createElement(Snippets.Container, { className: "text-midnight flex flex-wrap items-center lg:items-end justify-between mlg:px-11 md:px-3", tag: "section" },
            React.createElement("nav", { id: id, className: this.props.className }, linklist && linklist.links ? this.buildList(linklist.links, 0) : null)));
    };
    return Navigation;
}(React.PureComponent));
exports.Navigation = Navigation;
